<template>
  <el-dialog :visible.sync="visible" title="批量铺货配置" @close="closeHandle" width="800px">
    <el-form class="conf-form" label-width="140px">
      <el-form-item label="运费模版:" prop="shipSet">
        <div class="ship-wrp">
          <div class="item" v-for="(item, idx) in list" :key="idx">
            <div class="shopname">
              <img :src="item.icon" />
              <span :title="item.name">{{ item.name }}</span>
            </div>
            <el-select
              :loading="selectLoading"
              v-model="item.tbTemplateId"
              placeholder="请选择运费模板"
              clearable
              @visible-change="visibleSelectShips(item)"
              width="200px"
            >
              <el-option v-for="ship in shipsTemplate[item.shopId]" :key="ship.id" :label="ship.name" :value="ship.id"> </el-option>
            </el-select>
            <div class="ml_10"><el-link class="no-border" @click="refreshTemplate(item)">刷新模板</el-link></div>
          </div>
        </div>
        <div>
          <el-link
            href="https://wuliu.taobao.com/user/logis_tools.htm?tabSource=carriageTemplate&fromType=fromPublishGpfTaobao&forceSellerPay=false"
            target="_blank"
            >新增</el-link
          >
        </div>
      </el-form-item>

      <el-form-item label="店铺分类:" prop="shopClass">
        <div class="ship-wrp">
          <div class="item" v-for="(item, idx) in list" :key="idx">
            <div class="shopname">
              <img :src="item.icon" />
              <span :title="item.name">{{ item.name }}</span>
            </div>
            <el-cascader
              width="200px"
              :loading="selectLoading"
              :value="item.tbShopCat"
              :options="catMaps[item.shopId] || []"
              :props="catPrpos"
              :show-all-levels="false"
              placeholder="请选择店铺分类"
              showTags
              collapse-tags
              @visible-change="visibleSelectCat(item)"
              @change="v => catChange(v, item)"
            ></el-cascader>
            <div class="ml_10"><el-link class="no-border" @click="visibleSelectCat(item, true)">刷新</el-link></div>
          </div>
        </div>
        <div style="font-size: 12px">
          最多支持选择10项分类，<el-link href="https://siteadmin.taobao.com/category/index.htm" target="_blank">查看店铺分类</el-link>
        </div>
      </el-form-item>
      <el-form-item label="上架设置:">
        <el-radio-group v-model="tbStartTime">
          <el-radio :label="1">立即上架</el-radio>
          <el-radio :label="2">放入草稿箱</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleOK">继续铺货</el-button>
    </span>
  </el-dialog>
</template>

<script>
import taobao3Img from '@/assets/images/taobao3.png';
import { getTBTemplateList, getDistributionConfig } from '@servers/prod/conf/index.js';
import { refreshTaobaoFreightTemplte, getTaobaoFreightTemplate, getTaobaoSellerCatsGet } from '@api/prod/conf/index.js';
export default {
  components: {},
  data() {
    return {
      visible: false,
      list: [],
      tbStartTime: 0,
      shopList: [],
      shipsTemplate: {
        // 运费模板列表
      },
      catMaps: {},
      rules: {},
      selectLoading: false,
      catPrpos: {
        value: 'cid',
        label: 'name',
        multiple: true,
        emitPath: false,
      },
    };
  },
  computed: {},
  methods: {
    method_open(opts) {
      this.shopList = opts.shopList || [];
      this.visible = true;
      // this.init();
      this.getConf();
    },
    async handleOK() {
      const publishShopConfigs = this.list.map(item => {
        return {
          shopId: item.shopId,
          tbTemplateId: item.tbTemplateId,
          tbShopCat: item.tbShopCat || [],
          tbStartTime: this.tbStartTime,
        };
      });
      this.$emit('ok', { publishShopConfigs });
      this.closeHandle();
    },
    closeHandle() {
      this.visible = false;
    },
    // async init() {
    //   const templateData = await this.getShopTemplateValuation();
    //   this.list = this.shopList.map(shop => {
    //     const curTemplate = templateData.find(item => (item.shopId = shop.shopId));
    //     let tbTemplateId = '';
    //     if (curTemplate) {
    //       const temp = curTemplate?.templateList[0] || {};
    //       tbTemplateId = temp.templateId;
    //       this.shipsTemplate[shop.shopId] = [{ id: temp.templateId, name: temp.templateName }];
    //     }
    //     return {
    //       ...shop,
    //       icon: taobao3Img,
    //       tbTemplateId, // 运费模板
    //       tbShopCat: [], // 分类
    //     };
    //   });
    // },
    async getConf() {
      const res = await getDistributionConfig({ shopType: 'tb' });
      if (res) {
        this.tbStartTime = res.shelfState || 1;
        this.list = this.shopList.map(shop => {
          const curTemplate = (res.templateList || []).find(item => (item.shopId == shop.shopId));
          let tbTemplateId = '';
          if (curTemplate) {
            tbTemplateId = curTemplate.templateId;
            this.shipsTemplate[shop.shopId] = [{ id: tbTemplateId, name: curTemplate.templateName }];
          }
          return {
            ...shop,
            icon: taobao3Img,
            tbTemplateId, // 运费模板
            tbShopCat: [], // 分类
          };
        });
      }
    },
    async getTemplateList(userId) {
      const list = await getTBTemplateList({ userId: userId });
      if (list) {
        return list.map(ship => {
          return {
            name: ship.name,
            id: ship.templateId,
          };
        });
      }
      return [];
    },
    async refreshTemplate(item = {}) {
      const { shopId, userId } = item;
      this.selectLoading = true;
      const res = refreshTaobaoFreightTemplte([shopId]);
      this.selectLoading = false;
      if (res.result === 1) {
        this.$message.success('刷新模板成功');
        const list = await this.getTemplateList(userId);
        this.shipsTemplate[shopId] = list;
      }
    },
    async visibleSelectShips(item = {}) {
      const { shopId, userId, tbTemplateId } = item;
      if (
        !this.shipsTemplate[shopId]?.length ||
        (this.shipsTemplate[shopId].length === 1 && this.shipsTemplate[shopId][0].id == item.tbTemplateId)
      ) {
        this.selectLoading = true;
        const list = await this.getTemplateList(userId);
        if (tbTemplateId) {
          const idx = list.findIndex(item => item.id == tbTemplateId);
          if (idx === -1) {
            item.tbTemplateId = '';
          }
        }

        this.$set(this.shipsTemplate, shopId, list);
        this.selectLoading = false;
      }
    },
    catChange(v, item) {
      item.tbShopCat = v;
    },
    // 查询店铺分类列表
    async visibleSelectCat(item, forceUpdate) {
      const { shopId } = item;
      if (!forceUpdate && this.catMaps[shopId]) return;
      const res = await getTaobaoSellerCatsGet({ shopId });
      const list = res.data || [];
      this.$set(this.catMaps, shopId, list);
    },
    // 查询各淘宝店铺在快麦通的运费模板配置
    async getShopTemplateValuation() {
      let shopIdList = this.shopList.map(shop => shop.shopId);
      if (shopIdList.length === 0) return false;
      const res = await getTaobaoFreightTemplate({ shopIdList }, { isNeedLoading: true });
      const { data = [] } = res;
      return data;
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.conf-form {
  max-height: 500px;
  overflow: auto;
  .ship-wrp {
    margin-left: 5px;
    .item {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 20px;
      .shopname {
        width: 150px;
        display: flex;
        img {
          width: 26px;
          height: 26px;
          border-radius: 50%;
          vertical-align: middle;
        }
        span {
          font-size: 12px;
          vertical-align: middle;
          display: inline-block;
          margin-left: 10px;
          color: #606266;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }
    }
  }
  .ml_10 {
    margin-left: 10px;
  }
}
</style>